export const config = {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  version: __APP_VERSION__,
  environment: import.meta.env.VITE_ENV,
  amplitudeKey: import.meta.env.VITE_AMPLITUDE_API_KEY,
  authClientId: import.meta.env.VITE_AUTH_CLIENT_ID,
  apiHost: import.meta.env.VITE_API_HOST,
  inactivityThreshold: import.meta.env.VITE_USER_INACTIVE_THRESHOLD,
  abensonId: import.meta.env.VITE_ABENSON_ID,
  onlineHost: import.meta.env.VITE_ONLINE_HOST,
};

export type Config = typeof config;
